import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_month_year } from '../../functions/functions_formatting.js';
import { ReactComponent as IconStar } from '../../media/icons/star.svg';


export default class Review extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
        };
    }


    render() {
        return (
            <div className="trip__reviews__element">
                <div className="trip__reviews__element__headline">
                    <IconStar className={"trip__reviews__element__headline__icon" + (this.props.data.rating >= 1 ? " trip__reviews__element__headline__icon--active" : "")} />
                    <IconStar className={"trip__reviews__element__headline__icon" + (this.props.data.rating >= 2 ? " trip__reviews__element__headline__icon--active" : "")} />
                    <IconStar className={"trip__reviews__element__headline__icon" + (this.props.data.rating >= 3 ? " trip__reviews__element__headline__icon--active" : "")} />
                    <IconStar className={"trip__reviews__element__headline__icon" + (this.props.data.rating >= 4 ? " trip__reviews__element__headline__icon--active" : "")} />
                    <IconStar className={"trip__reviews__element__headline__icon" + (this.props.data.rating >= 5 ? " trip__reviews__element__headline__icon--active" : "")} />
                    <div className="text-bold">
                        {this.props.data.title}
                    </div>
                </div>
                <div className="trip__reviews__element__subline">
                    {this.props.data.anonymous &&
                        <div className="">
                            Anonymous
                        </div>
                    }
                    {!this.props.data.anonymous && this.props.data.user.username &&
                        <div className="">
                            <Link to={"/u/"+this.props.data.user.username}>{this.props.data.user.username}</Link>
                        </div>
                    }
                    {this.props.data.created &&
                        <div className="trip__reviews__element__subline__spacing">
                            |
                        </div>
                    }
                    {this.props.data.created &&
                        <div className="">
                            {format_month_year(this.props.data.created)}
                        </div>
                    }
                    {!this.props.data.anonymous && this.props.data.user.country &&
                        <div className="trip__reviews__element__subline__spacing">
                            |
                        </div>
                    }
                    {!this.props.data.anonymous && this.props.data.user.country &&
                        <div className="">
                            {this.props.data.user.country}
                        </div>
                    }
                </div>
                <div className="trip__reviews__element__textbox">
                    {this.props.data.description}
                </div>
            </div>
        )
    }
}
